<template>
	<v-sheet elevation="0">
		<CommonFlame :title="title">
			<v-row no-gutters class="mt-4" justify="end">
				<v-btn color="secondary" :disabled="!valid" @click="submitForm('draft')">
					<v-icon class="mr-1">mdi-content-save-outline</v-icon> 下書き保存
				</v-btn>
				<v-btn class="ml-2" color="secondary" :disabled="!valid" @click="openConfirmDialog">
					<v-icon class="mr-1">mdi-check</v-icon> 内容確認
				</v-btn>
			</v-row>
			<v-form ref="form" v-model="valid">
				<OrderConfirmationForm
					:order_confirmation.sync="order_confirmation"
					:matter_data.sync="matter"
				/>
			</v-form>
		</CommonFlame>
		<OrderConfirmationConfirmDialog
			:dialog.sync="confirmDialog"
			:matter="matter"
			:order_confirmation="order_confirmation"
      :actionText="'作成を完了して確認を依頼する'"
		/>
	</v-sheet>
</template>

<script>
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import rules from "../../helper/rules"

import CommonFlame from "../shared/CommonFlame.vue"
import OrderConfirmationForm from "./components/OrderConfirmationForm.vue"
import OrderConfirmationConfirmDialog from "../pending/components/OrderConfirmationConfirmDialog.vue"

export default {
	components: {
		CommonFlame,
		OrderConfirmationForm,
		OrderConfirmationConfirmDialog,
	},
	data() {
		return {
			title: "受注内容入力",
			order_confirmation: {
				files: [],
			},
			matter: {
				regular_customer_company: {},
				customer_company: {},
				plant_customer_company: {},
				matter_products: [],
			},

			confirmDialog: false,

			valid: false,
			errors: [],
			rules,
		}
	},
	mounted() {
		this.fetchMatter()
	},
	methods: {
		fetchMatter() {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/sales/matters/${this.$route.params.id}/order_confirmations/new`
			axios
				.get(url, { headers })
				.then((res) => {
					this.matter = res.data.matter
					// TODO MatterProductsの見積系項目を実績に初期として入れておく
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		openConfirmDialog() {
			this.confirmDialog = true
		},
		submitForm(status) {
			// TODO Formにする必要あり
			const headers = authenticate.setHeader()
			const params = {}
			const url = `/erp/v1/sales/matters/${this.$route.params.id}/order_confirmations`
			axios
				.post(url, params, {
					headers,
				})
				.then((res) => {
					this.$store.dispatch("setFlash", {
						type: "notice",
						text: "",
					})
					this.$router.push({ name: "" })
				})
				.catch((err) => {
					const errors = errorHandling.errorResponse(err)
					if (Array.isArray(errors)) {
						this.errors = errors
					}
				})
		},
	},
}
</script>